// Updates the `html` tags language attribute to reflect the users chosen
// language.
export const updateLanguageAttribute = (lang) => {
  document.documentElement.lang = lang;
}
